export enum UserRoles {
  superadmin = 'superadmin',
  admin = 'admin',
  teacher = 'teacher',
  user = 'user'
}
